import React from "react";
import Layout from "../../reusables/layout/layout";
import RegisterFormBeceCas from "../../Component/registerform/registerBeceCas";


const PaymentRegisterCas= () => {

  return (
    <div>
      <Layout>
        <RegisterFormBeceCas 
        examType={'CAS EXAMINATION'}
        serviceType={'cas'}
        navigateTo={'/cas/payment/login'}
        homeLink={"https://cas.examsboard.lagosstate.gov.ng/"}
         />
      </Layout>
    </div>
  );
};

export default PaymentRegisterCas;
